<template lang="html">
  <v-container
    fluid
    fill-height
    grid-list-xl>
    <v-layout
      justify-center
      wrap>
      <v-flex
        xs12>
        <busie-quote-card
          color="info"
          title="Bookings"
          text="Booked Trips"
          :quotes="displayedBookings">
          <template #filter>
            <busie-quote-filter
              :quotes="bookingsWithStops"
              @filtered="applyFilter"
              @clear="clearFilter"/>
          </template>
        </busie-quote-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import QuoteCard from '@/components/busie/QuoteCard'

export default {
  components: {
    'busie-quote-card': QuoteCard
  },
  data: () => ({
    filteredData: [],
    activeFilter: false
  }),
  computed: {
    bookedQuotes () {
      return this.getBooked
    },
    bookingsWithStops () {
      const map = this.stopsByTripMap
      const bookedQuotes = this.bookedQuotes
      const result = []
      map.forEach((stops, tripId) => {
        let min = 0
        let max = this.bookedQuotes.length - 1
        let guess
        while (max >= min) {
          guess = Math.floor((max + min)/2)
          if (bookedQuotes[guess].trip.id === tripId) {
            const quote = Object.assign({}, bookedQuotes[guess])
            quote.trip = Object.assign({}, bookedQuotes[guess].trip)
            const pickup = Object.assign({}, stops[0])
            pickup.date = this.dateById(pickup.date).date
            const additionalStops = stops.slice(1, stops.length - 1).map( s => {
              const stop = Object.assign({}, s)
              stop.date = this.dateById(stop.date).date
              return stop
            })
            quote.trip.stops = { pickup, additionalStops }
            result.push(quote)
            return
          }
          if (tripId > bookedQuotes[guess].trip.id) {
            min = guess + 1
          } else {
            max = guess - 1
          }
        }
      })
      return result
    },
    displayedBookings () {
      return this.activeFilter ? this.filteredData : this.bookedQuotes
    },
    ...mapGetters('quotes', [ 'getBooked' ]),
    ...mapGetters('dates', { dateById: 'byId' }),
    ...mapGetters('stops', ['stopsByTripMap'])
  },
  methods: {
    applyFilter (data) {
      this.activeFilter = true
      this.filteredData = data
    },
    clearFilter () {
      this.activeFilter = false
      this.filteredData = []
    }
  }
}
</script>

<style lang="css" scoped>
</style>
